var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { spinner } from 'elements/Loading';
let Button = class Button extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            this.props.onClick();
        };
    }
    render() {
        const _a = this.props, { children, onClick, loading, store, disabled } = _a, props = __rest(_a, ["children", "onClick", "loading", "store", "disabled"]);
        let isLoading;
        if (typeof loading === 'boolean') {
            isLoading = loading;
        }
        else {
            isLoading = store.UI.isLoading(loading);
        }
        return (React.createElement(StyledButton, Object.assign({}, props, { onClick: isLoading || disabled ? () => { } : this.handleClick, isLoading: isLoading, content: children, disabled: disabled }),
            React.createElement("span", null, children)));
    }
};
Button = __decorate([
    inject('store'),
    observer
], Button);
export default Button;
const StyledButton = cxs('button')(({ content, primary, isLoading, disabled }) => (Object.assign(Object.assign(Object.assign(Object.assign({ position: 'relative' }, (typeof content === 'string'
    ? { padding: Theme.size.space[1] }
    : undefined)), (primary
    ? { color: disabled ? undefined : Theme.color.primary }
    : undefined)), { ':hover': {
        color: disabled ? undefined : Theme.color.primary,
        cursor: disabled ? 'not-allowed' : undefined,
    } }), (isLoading ? Object.assign({ '> span': { visibility: 'hidden' } }, spinner) : undefined))));
StyledButton.propTypes = {
    primary: PropTypes.bool,
    isLoading: PropTypes.bool,
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Button.tsx
// module id = 369
// module chunks = 0